import { ReactNode } from 'react';
import { motion } from 'framer-motion';

export function Section({
  title,
  eyebrow,
  children,
  className = '',
}: {
  title?: string;
  eyebrow?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={`py-16 sm:py-24 ${className}`}>
      <div className="container-x">
        {eyebrow && (
          <div className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-accent">
            {eyebrow}
          </div>
        )}
        {title && (
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.5 }}
            className="heading-display mb-10"
          >
            {title}
          </motion.h2>
        )}
        {children}
      </div>
    </section>
  );
}
